export function isNull(value) {
  return (value === null || value === undefined);
}
